import { useScrollLock } from '@vueuse/core'

export function useBodyScrollLock() {
  const body = ref<HTMLElement | null>(window?.document?.body || null)
  const bodyScrollLocked = useScrollLock(body)
  return { bodyScrollLocked }
}
